import { Component, Input, OnInit } from "@angular/core";
/**
 * Generated class for the DayCalendarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: "info-popup",
  templateUrl: "info-popup.component.html",
  styleUrls: ["./info-popup.component.scss"]
})
export class InfoPopupComponent implements OnInit {
 
  @Input()
  public onClick = () => {}
  
  @Input()
  titleI18n: string
  @Input()
  messageI18n: string;
  @Input()
  buttonI18n: string;
  @Input()
  icon: string

  constructor() {

  }

  ngOnInit() {}

}
